const Styles = {
    'TextInputContainer': 'TextInput_TextInputContainer--8b8a6ecf',
    'minimal': 'TextInput_minimal--1bd5a6f7',
    'TextInput': 'TextInput_TextInput--ec829f13',
    'indicator': 'TextInput_indicator--6f13b716'
};

export default Styles;